/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfPaginatedListOfChildPackageOrganizationsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-child-package-organizations-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetPackageOrganizationsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-package-organizations-with-pagination-dto';
import { packageOrganizationsCancelPackageOrganization } from '../fn/package-organizations/package-organizations-cancel-package-organization';
import { PackageOrganizationsCancelPackageOrganization$Params } from '../fn/package-organizations/package-organizations-cancel-package-organization';
import { packageOrganizationsCreatePackageOrganizationGet } from '../fn/package-organizations/package-organizations-create-package-organization-get';
import { PackageOrganizationsCreatePackageOrganizationGet$Params } from '../fn/package-organizations/package-organizations-create-package-organization-get';
import { packageOrganizationsCreatePackageOrganizationPost } from '../fn/package-organizations/package-organizations-create-package-organization-post';
import { PackageOrganizationsCreatePackageOrganizationPost$Params } from '../fn/package-organizations/package-organizations-create-package-organization-post';
import { packageOrganizationsGetChildrenPackageOrganizationsWithPagination } from '../fn/package-organizations/package-organizations-get-children-package-organizations-with-pagination';
import { PackageOrganizationsGetChildrenPackageOrganizationsWithPagination$Params } from '../fn/package-organizations/package-organizations-get-children-package-organizations-with-pagination';
import { packageOrganizationsGetPackageOrganizationsAudit } from '../fn/package-organizations/package-organizations-get-package-organizations-audit';
import { PackageOrganizationsGetPackageOrganizationsAudit$Params } from '../fn/package-organizations/package-organizations-get-package-organizations-audit';
import { packageOrganizationsGetPackageOrganizationsWithPagination } from '../fn/package-organizations/package-organizations-get-package-organizations-with-pagination';
import { PackageOrganizationsGetPackageOrganizationsWithPagination$Params } from '../fn/package-organizations/package-organizations-get-package-organizations-with-pagination';

@Injectable({ providedIn: 'root' })
export class PackageOrganizationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `packageOrganizationsGetPackageOrganizationsWithPagination()` */
  static readonly PackageOrganizationsGetPackageOrganizationsWithPaginationPath = '/PackageOrganizations/GetPackageOrganizationsWithPagination';

  /**
   * لیست بسته های سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageOrganizationsGetPackageOrganizationsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageOrganizationsGetPackageOrganizationsWithPagination$Response(params: PackageOrganizationsGetPackageOrganizationsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPackageOrganizationsWithPaginationDto>> {
    return packageOrganizationsGetPackageOrganizationsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست بسته های سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageOrganizationsGetPackageOrganizationsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageOrganizationsGetPackageOrganizationsWithPagination(params: PackageOrganizationsGetPackageOrganizationsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPackageOrganizationsWithPaginationDto> {
    return this.packageOrganizationsGetPackageOrganizationsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPackageOrganizationsWithPaginationDto>): CustomResultOfPaginatedListOfGetPackageOrganizationsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `packageOrganizationsGetChildrenPackageOrganizationsWithPagination()` */
  static readonly PackageOrganizationsGetChildrenPackageOrganizationsWithPaginationPath = '/PackageOrganizations/GetChildrenPackageOrganizationsWithPagination';

  /**
   * لیست بسته هایی که فرزندان خرید کرده اند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageOrganizationsGetChildrenPackageOrganizationsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageOrganizationsGetChildrenPackageOrganizationsWithPagination$Response(params: PackageOrganizationsGetChildrenPackageOrganizationsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfChildPackageOrganizationsWithPaginationDto>> {
    return packageOrganizationsGetChildrenPackageOrganizationsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست بسته هایی که فرزندان خرید کرده اند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageOrganizationsGetChildrenPackageOrganizationsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageOrganizationsGetChildrenPackageOrganizationsWithPagination(params: PackageOrganizationsGetChildrenPackageOrganizationsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfChildPackageOrganizationsWithPaginationDto> {
    return this.packageOrganizationsGetChildrenPackageOrganizationsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfChildPackageOrganizationsWithPaginationDto>): CustomResultOfPaginatedListOfChildPackageOrganizationsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `packageOrganizationsCancelPackageOrganization()` */
  static readonly PackageOrganizationsCancelPackageOrganizationPath = '/PackageOrganizations/CancelPackageOrganization';

  /**
   * اگر هیچ ارسالی نزده باشه تا یک ساعت میتونه بسته را لغو کنه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageOrganizationsCancelPackageOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageOrganizationsCancelPackageOrganization$Response(params: PackageOrganizationsCancelPackageOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return packageOrganizationsCancelPackageOrganization(this.http, this.rootUrl, params, context);
  }

  /**
   * اگر هیچ ارسالی نزده باشه تا یک ساعت میتونه بسته را لغو کنه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageOrganizationsCancelPackageOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageOrganizationsCancelPackageOrganization(params: PackageOrganizationsCancelPackageOrganization$Params, context?: HttpContext): Observable<CustomResult> {
    return this.packageOrganizationsCancelPackageOrganization$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `packageOrganizationsCreatePackageOrganizationGet()` */
  static readonly PackageOrganizationsCreatePackageOrganizationGetPath = '/PackageOrganizations/CreatePackageOrganization';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageOrganizationsCreatePackageOrganizationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  packageOrganizationsCreatePackageOrganizationGet$Response(params?: PackageOrganizationsCreatePackageOrganizationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return packageOrganizationsCreatePackageOrganizationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageOrganizationsCreatePackageOrganizationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  packageOrganizationsCreatePackageOrganizationGet(params?: PackageOrganizationsCreatePackageOrganizationGet$Params, context?: HttpContext): Observable<Blob> {
    return this.packageOrganizationsCreatePackageOrganizationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `packageOrganizationsCreatePackageOrganizationPost()` */
  static readonly PackageOrganizationsCreatePackageOrganizationPostPath = '/PackageOrganizations/CreatePackageOrganization';

  /**
   * ثبت بسته برای سازمان برای خرید بسته برای فروش از اعتبار
   * برای خرید بسته در لیست بسته ها برای فروش یک دکمه برای هر سطر باشه به نام خرید از اعتبار و متد زیر صدا زده بشه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageOrganizationsCreatePackageOrganizationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageOrganizationsCreatePackageOrganizationPost$Response(params: PackageOrganizationsCreatePackageOrganizationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return packageOrganizationsCreatePackageOrganizationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * ثبت بسته برای سازمان برای خرید بسته برای فروش از اعتبار
   * برای خرید بسته در لیست بسته ها برای فروش یک دکمه برای هر سطر باشه به نام خرید از اعتبار و متد زیر صدا زده بشه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageOrganizationsCreatePackageOrganizationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageOrganizationsCreatePackageOrganizationPost(params: PackageOrganizationsCreatePackageOrganizationPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.packageOrganizationsCreatePackageOrganizationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `packageOrganizationsGetPackageOrganizationsAudit()` */
  static readonly PackageOrganizationsGetPackageOrganizationsAuditPath = '/PackageOrganizations/GetPackageOrganizationsAudit';

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `packageOrganizationsGetPackageOrganizationsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageOrganizationsGetPackageOrganizationsAudit$Response(params: PackageOrganizationsGetPackageOrganizationsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return packageOrganizationsGetPackageOrganizationsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `packageOrganizationsGetPackageOrganizationsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  packageOrganizationsGetPackageOrganizationsAudit(params: PackageOrganizationsGetPackageOrganizationsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.packageOrganizationsGetPackageOrganizationsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
